// extracted by mini-css-extract-plugin
module.exports = {"container":"MiniMenu_container__1A7y4"};